
















































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import _ from "lodash";
import { Form } from "element-ui";
import config from "../config/index";
import { exportFiles, exportPostFiles, formatUrl } from "../common/util";
import { mapState, mapActions } from "vuex";
import store from "../store/store";
import { TaskData } from "../types/common";
import { OwndbManage, CheckFileDto, OptData } from "../types/owndbmanage";
import { uploadFileStatus } from "../common/filters";
import moment from "moment";

declare var _hmt: any;
declare var captcha: any;

export default Vue.extend({
  name: "OwnDbManage",
  data(): OwndbManage {
    return {
      isShowTest: false,
      isShowZipNum: false,
      doneZipNum: 0,
      timer: null,
      IsUsed: false,
      isCanUpLoad: true,
      dialogAddDb: false,
      isShowAdding: false,
      CheckSelfDBId: "",
      dialogDeleteDbName: false,
      selfIndexLoading: true,
      checkDBName: "",
      dialogCreateDbName: false,
      checkResultList: [],
      dialogtest: true,
      listLoading: false,
      isShowDbIndexOpt: false,
      isShowBuilding: false,
      dialogCreateDb: false,
      isShowDBIndexInfo: false,
      isShowSlefList: false,
      isShowSearchList: false,
      isOpenTips: true,
      selectFileList: [],
      checkIds: [],
      uploadFileList: [],
      copyUploadFileList: [],
      cacheUploadFileList: [],
      fileNum: 0,
      isCanCheck: false,
      selfDBStatus: "",
      CheckSelfDBName: "",
      HasCreated: 0,
      TotalCount: 0,
      CreateTime: "",
      selfVisible: false,
      selfFolder: false,
      isCheckTip: false,
      pageObj: {
        total: 100,
        pageIndex: 1,
        pageSize: 10,
      },
      pageSizeList: [10, 20, 50, 100],
      $refs: {
        ruleForm: Form,
      },
      pickerOption: {
        disabledDate(time: Date) {
          return time.getTime() > Date.now();
        },
      },
      searchData: {
        Title: "", // 题名/文件夹
        Name: "", // 文件夹名称
        StartTime: "", // 结束检测时间
        EndTime: "", // 开始检测时间
        IsExport: false,
        CheckSelfDBId: "",
        Offset: 0, // 分页偏移量
        Limit: 10, // 分页大小
      },
      ruleForm: {
        title: "",
        beginTime: "",
        endTime: "",
        isExcelExport: 0,
        CheckSelfDBId: "",
      },
      total: 0,
      rules: {
        title: [
          {
            required: true,
            validator: (rule: any, value: any, callback: any) => {
              if (value === "") {
                // this.isShowAdding = false;
                callback(new Error("请填写自建库名称"));
              } else if (value.length > 30) {
                callback(new Error("自建库名称不能大于30个字符"));
              } else {
                // isShowAdding = true;
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.getCheckDBIndexInfo();
    if (this.CheckSelfDBId) {
      this.isCanUpLoad = false;
    } else {
      this.isCanUpLoad = true;
    }
    this.initWebLoader();
    // if(this.$route.query.id === '2') {
    //   this.handleaddSelfDb(true, false);
    // }
    // this.$nextTick(() => {
    //   this.initUploader('#newPaper', {
    //     multiple: true,
    //     fileNumLimit: 100,
    //     type: 'newPaper',
    //     selfDbname: this.checkDBName || this.ruleForm.title
    //   });
    // });
  },
  computed: mapState({
    paperType: (state: any) => store.getters.getPaperType,
    checkType: (state: any) => store.getters.getCheckType,
    isShowIntro: (state: any) => store.getters.getIntro,
    uploader: (state: any) => store.getters.getUploader,
  }),
  watch: {},
  methods: {
    dialogCreateDbClose(){
      this.dialogCreateDb = false;
      this.returnSelfIndex();
    },
    dialogAddDbClose(){
      this.dialogAddDb = false;
      this.returnSelfIndex();
    },
    // 清空查询条件
    clear() {
      this.searchData = {
        Title: "", // 题名/文件夹
        Name: "", // 文件夹名称
        StartTime: moment(this.searchData.EndTime)
          .subtract(3, "months")
          .format("YYYY-MM-DD"), // 结束检测时间
        EndTime: moment().format("YYYY-MM-DD"), // 开始检测时间
        IsExport: false,
        CheckSelfDBId: "",
        Offset: 0, // 分页偏移量
        Limit: 10, // 分页大小
      };
      // this.searchData.endtime = moment().format('YYYY-MM-DD');
      // this.searchData.starttime = moment(this.searchData.endtime).subtract(7, 'day').format('YYYY-MM-DD');
      this.getCheckResult();
    },
    // 初始化webloader
    initWebLoader() {
      this.$nextTick(() => {
        this.initUploader("#newPaper", {
          multiple: true,
          fileNumLimit: 100,
          type: "newPaper",
          selfDbname: this.CheckSelfDBId,
        });
      });
      this.$nextTick(() => {
        this.initUploaderZip("#newPaperZip", {
          multiple: true,
          fileNumLimit: 100,
          type: "newPaper",
          selfDbname: this.CheckSelfDBId,
        });
      });
    },
    handleSelfSearch() {
      this.selfVisible = true; 
    },
    startSelfSearch() {
      this.selfVisible = false;
      this.isCheckTip = true;
    },
    // 跳转到检测结果
    toCheckResult() {
      let path = '/myCheckInfo';
      
      this.$router.push({
        path
      });

    },
    selefAdding() {
      const mark = this.judgeStatus();
      if (!mark) {
        this.$alert(
          "文件列表中包含上传失败的送检文献，请从列表中删除这些文献后再进行送检。",
          "提示"
        );
        return false;
      }
      this.$http
        .post("/api/CheckDB/BuildOrAddDB", {
          CheckSelfDBId: this.CheckSelfDBId,
          Type: "增量",
        })
        .then((data: any) => {
          if (data.data.success) {
            this.dialogAddDb = true;
            this.getNotCheckList();
          }
        });
    },
    // 增量3
    clickAddDbName() {
      this.isShowDBIndexInfo = false;
      this.isShowSlefList = false;
      // this.isShowBuilding = true;
      this.isShowTest = true;
      this.isShowSearchList = false;
      this.isShowDbIndexOpt = false;
      this.isShowAdding = true;
      this.isCanUpLoad = false;
      this.initWebLoader();
    },
    ClickDeleteDbName() {
      this.dialogDeleteDbName = true;
    },
    // 删除自建库
    deleteDB() {
      this.$http
        .delete("/api/CheckDB/DeleteDB", {
          data: {
            SelfDBId: this.CheckSelfDBId,
          },
        })
        .then((data: any) => {
          this.getCheckDBIndexInfo();
          this.dialogDeleteDbName = false;
        });
    },
    returnSelfIndex() {
      if (this.CheckSelfDBId) {
        this.isShowSlefList = false;
        this.isShowDBIndexInfo = true;
      } else {
        this.isShowDBIndexInfo = false;
        this.isShowSlefList = true;
      }
      this.isShowBuilding = false;
      this.isShowTest = false;
      this.isShowSearchList = false;
      this.isShowDbIndexOpt = false;
      this.isShowAdding = false;
      this.getCheckDBIndexInfo();
    },
    //开始建库
    startCheck() {
      if (this.uploadFileList.length < 2) {
        this.$alert(" 至少需要两篇内容不同的文献，才能建库！", "提示");
        return false;
      }
      const mark = this.judgeStatus();
      if (!mark) {
        this.$alert(
          "文件列表中包含上传失败的送检文献，请从列表中删除这些文献后再进行送检。",
          "提示"
        );
        return false;
      }
      this.$http
        .post("/api/CheckDB/BuildOrAddDB", {
          CheckSelfDBId: this.CheckSelfDBId,
          Type: "建库",
        })
        .then((data: any) => {
          if (data.data.success) {
            this.dialogCreateDb = true;
            this.getNotCheckList();
          }
        });
    },
    saveSelfDbName(formName: string) {
      this.$refs[formName].validate((valid: any) => {
        if (valid) {
          this.$http
            .post("/api/CheckDB/AddCheckDB", {
              CheckSelfDBName: this.ruleForm.title,
            })
            .then((data: any) => {
              if (data.data.checkSelfDBId) {
                this.isCanUpLoad = false;
                this.CheckSelfDBId = data.data.checkSelfDBId;
                this.checkDBName = this.ruleForm.title;
                this.initWebLoader();
              } else {
                this.CheckSelfDBId = "";
              }
            });
          // this.checkDBName = this.ruleForm.title;
          this.dialogCreateDbName = true;
        }
      });
    },
    // 改变分页size
    handleSizeChange(val: number) {
      this.pageObj.pageSize = val;
      this.pageObj.pageIndex = 1;
      this.setSearchPage();
      this.getCheckResult();
    },
    // 改变当前页
    handleCurrentChange(val: number) {
      this.pageObj.pageIndex = val;
      this.setSearchPage();
      this.getCheckResult();
    },
    // 设置分页
    setSearchPage() {
      this.searchData.Offset =
        (this.pageObj.pageIndex - 1) * this.pageObj.pageSize;
      this.searchData.Limit = this.pageObj.pageSize;
    },
    // 获取库内文献
    getCheckResult() {
      const isCanSearch = this.checkSearchData();
      if (!isCanSearch) {
        return false;
      }
      this.listLoading = true;
      this.searchData.CheckSelfDBId = this.CheckSelfDBId;
      this.checkResultList = [];
      //DetectResult/GetCheckList
      this.$http
        .get("/api/CheckDB/GetCheckSelfDBFileList", {
          params: this.searchData,
        })
        .then((data: any) => {
          // this.checkResultObj = res.data;
          this.$store.dispatch("setCheckResult", data.data.data);
          this.checkResultList = data.data.data;
          this.pageObj.total = data.data.total;
          this.$nextTick(() => {
            this.listLoading = false;
            // this.initFixTable();
          });
        });
    },
    // 校验查询条件是否正确
    checkSearchData() {
      if (this.searchData.StartTime > this.searchData.EndTime) {
        this.$alert(" 开始时间不能大于结束时间！", "提示");
        return false;
      }
      return true;
    },
    // 导出
    exportCheckResult() {
      // 事件追踪start
      _hmt.push([
        "_trackEvent",
        "我的检测-检测信息",
        "检测信息列表导出",
        "事件价值",
        1,
      ]);
      // end
      const isCanSearch = this.checkSearchData();
      // if (!isCanSearch) {
      //   return false;
      // }
      // exportFiles(formatUrl(this.searchData, `${config.api}/api/Check/Export/CheckResultList`));
      this.searchData.IsExport = true;
      exportFiles(
        formatUrl(
          this.searchData,
          `${config.api}/api/CheckDB/GetCheckSelfDBFileList`
        )
      );
      this.searchData.IsExport = false;
    },
    // 库内文献 4
    ShowSearchList() {
      this.isShowSearchList = true;
      this.isShowDBIndexInfo = false;
    },
    ShowDbIndexOpt() {
      this.isShowDbIndexOpt = !this.isShowDbIndexOpt;
    },
    // 设置检测时间
    setCheckTime(num: any, type: string) {
      this.searchData.EndTime = moment(new Date()).format("YYYY-MM-DD");
      this.searchData.StartTime = moment(this.searchData.EndTime)
        .subtract(num, type)
        .format("YYYY-MM-DD");
      this.getNotCheckList();
    },
    // 清空、重置表单
    resetForm() {
      this.clear();
    },
    // 检测时间发生变化时触发
    changeTime() {
      // 日期转成字符串比较
      // this.searchData.beginTime = new Date(this.searchData.beginTime).toJSON();
      // this.searchData.endTime = new Date(this.searchData.endTime).toJSON();
    },
    // 判断上传文件状态
    judgeStatus() {
      let mark = true;
      this.uploadFileList.forEach((item: any) => {
        if (item.uploadStatus !== "Success") {
          mark = false;
        }
      });
      return mark;
    },
    // 修改温馨提示状态
    changeTipsStatus() {
      this.isOpenTips = !this.isOpenTips;
      // 记录用户操作
      localStorage.setItem("isOpenTips", this.isOpenTips.toString());
    },
    // 建库2
    handleaddSelfDb(isShow: boolean, isShowAl: boolean) {
      if (isShowAl) {
        this.isCanUpLoad = true;
      } else {
        this.isCanUpLoad = false;
      }
      this.ruleForm.title = "";
      // this.isShowBuilding = isShow;
      this.isShowSlefList = !isShow;
      this.isShowDBIndexInfo = !isShow;
      this.initWebLoader();
      // this.isShowBuilding = true;
      this.isShowTest = true;
      // this.isShowDBIndexInfo = false;
      // this.isShowBuilding = true;
    },
    //获取自建库首页信息
    getCheckDBIndexInfo() {
      this.$http.get("/api/Setting/GetCheckDBIndexInfo").then((data: any) => {
        this.selfIndexLoading = false;
        if (data.data.checkSelfDBId) {
          this.isShowDBIndexInfo = true;
          this.isShowSlefList = false;
        } else {
          this.isShowSlefList = true;
          this.isShowDBIndexInfo = false;
        }
        this.checkDBName = data.data.checkSelfDBName;
        this.IsUsed = data.data.isUsed;
        this.CheckSelfDBName = data.data.checkSelfDBName;
        this.HasCreated = data.data.usedCount;
        this.TotalCount = data.data.totalCount;
        this.CreateTime = data.data.createTime;
        this.selfDBStatus = data.data.dbStatus;
        this.CheckSelfDBId = data.data.checkSelfDBId;
        if (this.CheckSelfDBId) {
          this.getCheckResult();
        }
      });
    },
    // 选择、取消上传文件钩子方法
    handleSelectionChange(val: CheckFileDto[]) {
      this.selectFileList = val;
      this.checkIds = [];
      _.forEach(this.selectFileList, (value: CheckFileDto) => {
        this.checkIds.push(value.checkId);
      });
    },
    // 删除选中文件
    delFileList(row?: any) {
      if (this.checkIds.length === 0 && !row) {
        this.$alert(" 请至少选择一条检测信息！", "提示");
        return false;
      }
      this.$confirm("是否确认删除？", "提示", { type: "warning" })
        .then(() => {
          let checkIdList: any[] = [];
          // 单个删除
          if (row) {
            if (row.uploadMessage === "waiting") {
              this.$alert(" 选中论文中有未上传成功的论文，请重新选择", "提示");
              return false;
            }
            this.uploadFileList = _.differenceWith(
              this.uploadFileList,
              [row],
              _.isEqual
            );
            checkIdList = [row.checkId];
          } else {
            for (var i = 0; i < this.uploadFileList.length; i++) {
              if (this.uploadFileList[i].uploadMessage === "waiting") {
                this.$alert(
                  " 选中论文中有未上传成功的论文，请重新选择",
                  "提示"
                );
                return false;
              }
            }
            // 批量删除
            this.uploadFileList = _.differenceWith(
              this.uploadFileList,
              this.selectFileList,
              _.isEqual
            );
            checkIdList = this.checkIds;
          }
          this.$store.dispatch("setLoading", {
            isShow: true,
          });
          this.$http
            .delete("/api/CheckDB/DeleteFile", {
              data: {
                checkIds: checkIdList,
              },
            })
            .then((data: any) => {
              this.$store.dispatch("setLoading", {
                isShow: false,
              });
              this.handleSelectionChange([]);
              this.$message({
                message: `删除成功`,
                type: "success",
              });
            })
            .catch(() => {
              this.$store.dispatch("setLoading", {
                isShow: false,
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 获取上传文件列表
    getNotCheckList() {
      this.$http.get("/api/CheckDB/CheckStatus").then((data: any) => {
        this.fileNum = 0;
        this.uploadFileList = data.data;
        this.fileNum = this.uploadFileList.length;
      });
    },
    // 上传成功回调
    handleSuccess(file: any, response: any) {
      if (response.success) {
        this.uploadFileList.forEach((item: any, index: any) => {
          if (file.id === item.id) {
            response.author = file.author;
            response.title = file.title;
            response.uploadMessage = "Success";
            file.uploadMessage = "Success";
            // response.checkId = response.checkId
            this.uploadFileList.splice(index, 1, response);
          }
        });
      } else {
        this.uploadFileList.forEach((item: any, index: any) => {
          if (file.id === item.id) {
            response.author = file.author;
            response.title = file.title;
            response.uploadMessage = response.message;
            // response.checkId = response.checkId
            this.uploadFileList.splice(index, 1, response);
            file.uploadMessage = response.message;
          }
        });
      }
      this.copyUploadFileList = this.uploadFileList.concat([]);
    },
    // 上传成功回调
    handleZipSuccess(file: any, response: any) {
      if (response.success) {
        this.$message({
          message: response.message,
          type: "success",
        });
        //  this.uploadFileList.forEach((item: any, index: any) => {
        // if (file.id === item.id) {
        //   response.author = file.author
        //   response.title = file.title
        //   response.uploadStatus = 'Success'
        //   this.uploadFileList.splice(index, 1, response);
        // }
        // });
      } else {
        //  this.uploadFileList.forEach((item: any, index: any) => {
        //   if (file.id === item.id) {
        //     response.author = file.author
        //     response.title = file.title
        //     response.uploadStatus = response.message
        //     this.uploadFileList.splice(index, 1, response);
        //   }
        // });
      }
      // this.initWebLoader();
      this.copyUploadFileList = this.uploadFileList.concat([]);
      // this.initWebLoader();
      this.getNotCheckList();
      this.isShowZipNum = false;
      clearInterval(this.timer);
    },
    // 上传错误回调
    handleError(error: any, file: any, type: string) {
      if (error === "Q_TYPE_DENIED" && file.size !== 0) {
        this.$message({
          message: "文件格式不正确，仅限doc,docx",
          type: "error",
        });
      }
      // this.initWebLoader();
    },
    // 初始化上传组件
    initUploader(domId: string, opt: OptData) {
      // 初始化前，如果有上传对象，清空上传队列
      if (this.uploader) {
        this.uploader.reset();
        this.getNotCheckList();
      }
      const webUploaderOpt = {
        auto: true, // 是否自动上传
        fileNumLimit: opt.fileNumLimit,
        threads: 1,
        // swf文件路径
        swf: "/public/js/Uploader.swf?_t=" + new Date().getTime(),
        // 文件接收服务端。
        server: `${config.api}/api/CheckDB/Upload?dbid=${opt.selfDbname}`,
        // 选择文件的按钮。可选。
        // 内部根据当前运行是创建，可能是input元素，也可能是flash.
        pick: {
          id: domId,
          multiple: opt.multiple,
        },
        // 不压缩image, 默认如果是jpeg，文件上传前会压缩一把再上传！
        resize: false,
        duplicate: true,
        accept: {
          title: "Documents",
          extensions: "doc,docx",
          mimeTypes: ".docx,.doc",
        },
      };
      const WebUploader: any = (window as any).WebUploader;
      const uploader = WebUploader.create(webUploaderOpt);
      this.$store.dispatch("setUploader", uploader);
      //上传前传参数到服务端
      uploader.on("uploadBeforeSend", function(
        obj: any,
        data: any,
        headers: any
      ) {
        data.dbid = opt.selfDbname;
        // data.file = obj.file
      });
      // 进入队列前触发
      uploader.on("beforeFileQueued", (file: any) => {
        // this.$alert('正在上传，请稍等！', '提示');
      });
      // 当有文件被添加进队列的时候
      uploader.on("fileQueued", (file: any) => {
        if (opt.type === "newPaper") {
          const regex = /^([^@]+)@([^@]+)$/;
          if (regex.test(file.name)) {
            file.author = file.name.split("@")[0];
            file.title = file.name.split("@")[1].split(".")[0];
          } else {
            file.title = file.name;
          }
          file.uploadMessage = "waiting";
          this.cacheUploadFileList.push(file);
        }
        // 单篇上传加遮罩层
        if (!opt.multiple) {
          this.$store.dispatch("setLoading", {
            isShow: true,
            text: "正在上传，请稍后！",
          });
        }
      });
      uploader.on("startUpload", (file: any, response: any) => {
        this.fileNum = 0;
        if (this.fileNum + uploader.getFiles().length > 100 && opt.multiple) {
          // this.$message({
          //   message: `本次可上传文献数量为${100 - this.fileNum}篇，请重新选择或删除部分已上传文献`,
          //   type: 'error'
          // });
          // uploader.reset();
          // this.cacheUploadFileList = [];
        } else if (opt.multiple) {
          this.isCanCheck = true;
          this.fileNum = this.fileNum + uploader.getFiles().length;
          this.uploadFileList = this.uploadFileList.concat(
            this.cacheUploadFileList
          );
          this.copyUploadFileList = this.uploadFileList.concat([]);
        }
      });
      uploader.on("uploadSuccess", (file: any, response: any) => {
        if (!response) {
          this.$message({
            message: response.message,
            type: "error",
          });
          return false;
        }
        this.handleSuccess(file, response);
      });
      uploader.on("error", (error: any, file: any) => {
        this.handleError(error, file, opt.type);
      });
      uploader.on("uploadFinished", () => {
        this.isCanCheck = false;
        this.cacheUploadFileList = [];
        uploader.reset();
        this.$nextTick(() => {
          this.fileNum = this.uploadFileList.length;
          // 单篇上传加遮罩层
          if (!opt.multiple) {
            this.$store.dispatch("setLoading", {
              isShow: false,
              text: "正在加载...",
            });
          }
        });
      });
    },
    initUploaderZip(domId: string, opt: OptData) {
      // 初始化前，如果有上传对象，清空上传队列
      if (this.uploader) {
        this.fileNum = 0;
        this.uploader.reset();
        this.getNotCheckList();
      }
      const webUploaderOptZip = {
        auto: true, // 是否自动上传
        fileNumLimit: opt.fileNumLimit,
        threads: 1,
        // swf文件路径
        swf: "/public/js/Uploader.swf?_t=" + new Date().getTime(),
        // 文件接收服务端。
        server: `${config.api}/api/CheckDB/UploadRar?dbid=${opt.selfDbname}`,
        // 选择文件的按钮。可选。
        // 内部根据当前运行是创建，可能是input元素，也可能是flash.
        pick: {
          id: domId,
          multiple: opt.multiple,
        },
        // 不压缩image, 默认如果是jpeg，文件上传前会压缩一把再上传！
        resize: false,
        duplicate: true,
        accept: {
          title: "Documents",
          extensions: "zip,rar",
          mimeTypes: ".zip,.rar",
        },
      };
      const WebUploader: any = (window as any).WebUploader;
      this.fileNum = 0;
      const uploaderzip = WebUploader.create(webUploaderOptZip);
      this.$store.dispatch("setUploader", uploaderzip);
      //上传前传参数到服务端
      uploaderzip.on("uploadBeforeSend", function(
        obj: any,
        data: any,
        headers: any
      ) {
        data.dbid = opt.selfDbname;
      });
      // 进入队列前触发
      uploaderzip.on("beforeFileQueued", (file: any) => {
        // if (file.size === 0) {
        //   this.$message({
        //     message: '文件大小为0kb，送检内容为空，请重新上传',
        //     type: 'error'
        //   });
        //   return false;
        // } else
        this.fileNum = 0;
        if (file.size > 1048576000) {
          this.$message({
            message: "压缩包大小超过1000M，请重新上传",
            type: "error",
          });
          return false;
        }
      });
      // 当有文件被添加进队列的时候
      uploaderzip.on("fileQueued", (file: any) => {
        this.fileNum = 0;
        if (opt.type === "newPaper") {
          const regex = /^([^@]+)@([^@]+)$/;
          if (regex.test(file.name)) {
            file.author = file.name.split("@")[0];
            file.title = file.name.split("@")[1].split(".")[0];
          } else {
            file.title = file.name;
          }
          // file.uploadStatus = 'waiting';
          // this.cacheUploadFileList.push(file);
        }
        // 单篇上传加遮罩层
        if (!opt.multiple) {
          this.$store.dispatch("setLoading", {
            isShow: true,
            text: "正在上传，请稍后！",
          });
        }
      });
      uploaderzip.on("startUpload", (file: any, response: any) => {
        this.fileNum = 0;
        if (
          this.fileNum + uploaderzip.getFiles().length > 100 &&
          opt.multiple
        ) {
          // this.$message({
          //   message: `本次可上传文献数量为${100 - this.fileNum}篇，请重新选择或删除部分已上传文献`,
          //   type: 'error'
          // });
          // uploaderzip.reset();
          // this.cacheUploadFileList = [];
        } else if (opt.multiple) {
          // this.isCanCheck = true;
          // this.fileNum = this.fileNum + uploaderzip.getFiles().length;
          // this.uploadFileList = this.uploadFileList.concat(this.cacheUploadFileList);
          // this.copyUploadFileList = this.uploadFileList.concat([]);
        }
        this.isShowZipNum = true;
        clearInterval(this.timer);
        this.timer = setInterval(() => {
          this.getNotCheckList();
        }, 5000);
      });
      uploaderzip.on("uploadSuccess", (file: any, response: any) => {
        if (!response) {
          this.$message({
            message: response.message,
            type: "error",
          });
          return false;
        } else {
          this.$message({
            message: response.message,
            type: "error",
          });
        }
        this.handleZipSuccess(file, response);
      });
      uploaderzip.on("error", (error: any, file: any) => {
        this.handleError(error, file, opt.type);
      });
      uploaderzip.on("uploadFinished", () => {
        this.isCanCheck = false;
        this.cacheUploadFileList = [];
        uploaderzip.reset();
        this.$nextTick(() => {
          this.fileNum = this.uploadFileList.length;
          // 单篇上传加遮罩层
          if (!opt.multiple) {
            this.$store.dispatch("setLoading", {
              isShow: false,
              text: "正在加载...",
            });
          }
        });
      });
    },
  },
  created() {
    this.setCheckTime(3, "months");
    this.$store.dispatch("setPaperType", "newPaper");
    this.$store.dispatch("setCheckType", "upload");
    this.getNotCheckList();
    this.getCheckDBIndexInfo();
    // 获取用户操作
    this.isOpenTips = localStorage.getItem("isOpenTips") !== "false";
  },
});
